import Text from "@icons/text/text_purple.svg";
import Video from "@icons/video/video-big.svg";
import TextAndImage from "@icons/text&image/text&image.svg";
import Image from "@icons/image/image-purple.svg";
import { AssetTypeField } from "./enum";

export const radioGroupClassName = "bg-white border-1 rounded-lg px-6 pb-6 pt-5 mb-2";
export const DEFAULT_NUMBER_OF_IMAGES = "1";
export const HEADLINE_OVER_IMAGES_TEXT = "Headline over images";

export const ASSET_TYPE_ERROR = "assetTypeError";
export const CONTINUE = "Continue";

export const COPY_ERROR_MESSAGE_ID = "copyOutputMessageID";
export const VIDEO_SCRIPT_ID = "videoScriptID";

export const FIELD_NAME = {
  PROJECT_NAME: "title",
  CHANNEL: "channel",
  COPY_OUTPUT: "copyOutput",
  IMAGE_DIMENSION: "imageDimensions",
  SPECIFICATIONS: "specifications",
  SCRIPT_LENGTH: "scriptLength",
  PRODUCT_IMAGE_OPTIONS: "productImageOption",
  REFERENCE_IMAGE_COUNT: "referenceImagesCount",
  REFERENCE_IMAGES_DISCLAIMER_CHECKED: "referenceImagesDisclaimerChecked",
} as const;

export const ASSETS_FIELD_LABEL = {
  CHANNEL_NAME: "channelName",
  OUTPUT_NAME: "outputName",
  SPECIFICATION_SELECTION: "specificationName",
  DIMENSION_SELECTION: "dimensionName",
  VIDEO_LENGTH_SELECTION: "videoLengthName",
};

export const PROJECT_OPTIONS_CONSTANT = {
  HEADING_ID: "exploreOptionsId",
  TITLE: "Select project options",
  DESCRIPTION:
    "Tell us what type of asset you'd like to create and your intended channels. Generate text or video scripts, create images, or combine imagery and messaging for digital content and marketing concepts.",
  PROJECT_LABEL: "Project Name",
  ASSET_TYPE_LABEL: "Choose the type of asset you want to create",
  ASSET_TYPE_POPOVER_CONTENT:
    "Selecting any asset type will allow you to specify the intended channel. When generating images, you can also choose the dimensions of your image.",
  SELECT_DROPDOWN_LABEL: "Indicate the number of options to generate",
  ASSET_TYPE_OPTIONS: [
    { label: AssetTypeField.TEXT, svg: Text },
    { label: AssetTypeField.VISUAL, svg: Image },
    { label: AssetTypeField.VISUAL_AND_TEXT, svg: TextAndImage },
    { label: AssetTypeField.VIDEO_SCRIPT, svg: Video },
  ],
  TEXT_LABEL: "Select the type of copy output",
  SELECT_OPTIONS: [
    { id: "option-1", label: "1" },
    { id: "option-2", label: "2" },
    { id: "option-3", label: "3" },
    { id: "option-4", label: "4" },
  ],
  TEXT_OPTIONS: [
    {
      id: "open",
      label: "Open",
      ariaLabel: "Open",
    },
    {
      id: "shortForm",
      label: "Short Form",
      ariaLabel: "Short Form",
    },
    {
      id: "longForm",
      label: "Long Form",
      ariaLabel: "Long Form",
    },
    {
      id: "headlines",
      label: "Headlines",
      ariaLabel: "Headlines",
    },
  ],
  CHANNEL_LABEL: "Channel (optional)",
  CHANNEL_OPTIONS: [
    {
      id: "instagram",
      label: "Instagram",
      ariaLabel: "Instagram",
    },
    {
      id: "tiktok",
      label: "TikTok",
      ariaLabel: "TikTok",
    },
    {
      id: "facebook",
      label: "Facebook",
      ariaLabel: "Facebook",
    },
    {
      id: "google",
      label: "Google",
      ariaLabel: "Google",
    },
    {
      id: "other",
      label: "Other",
      ariaLabel: "Other",
    },
  ],
  IMAGE_DIMENSION_LABEL: "Select the dimensions of your image:",
  IMAGE_DIMENSION_OPTIONS: [
    {
      id: "1024 x 1024 px (1:1)",
      label: "1024 x 1024 px (1 : 1)",
      ariaLabel: "1024 x 1024 px (1 : 1)",
    },
    {
      id: "896 x 1152 px (3:4)",
      label: "896 x 1152 px (3 : 4)",
      ariaLabel: "896 x 1152 px (3 : 4)",
    },
    {
      id: "1152 x 896 px (4:3)",
      label: "1152 x 896 px (4 : 3)",
      ariaLabel: "1152 x 896 px (4 : 3)",
    },
    {
      id: "768 x 1344 px (9:16)",
      label: "768 x 1344 px (9 : 16)",
      ariaLabel: "768 x 1344 px (9 : 16)",
    },
    {
      id: "1344 x 768 px (16:9)",
      label: "1344 x 768 px (16 : 9)",
      ariaLabel: "1344 x 768 px (16 : 9)",
    },
  ],
  SPECIFICATIONS_LABEL: "Select specifications",
  SPECIFICATIONS_OPTIONS: [
    {
      id: "headlineOverImages",
      label: HEADLINE_OVER_IMAGES_TEXT,
      ariaLabel: HEADLINE_OVER_IMAGES_TEXT,
    },
    {
      id: "imageAndShortDescription",
      label: "Image and short description",
      ariaLabel: "Image and short description",
    },
  ],
  VIDEO_SCRIPT_LENGTH_LABEL: "Select the length of the video script",
  VIDEO_SCRIPT_LENGTH_OPTIONS: [
    {
      id: ":06",
      label: ":06",
      ariaLabel: ":06",
    },
    {
      id: ":15",
      label: ":15",
      ariaLabel: ":15",
    },
    {
      id: ":30",
      label: ":30",
      ariaLabel: ":30",
    },
  ],
  VIDEO_SCRIPT_INCLUDE_IMAGE_TEXT: "Include image",
  PROJECT_NAME_REQUIRED_ERROR: "A project name is required. Try choosing something specific to your campaign concept.",
  COPY_OUTPUT_REQUIRED_ERROR: "Please select a copy output",
  IMAGE_DIMENSION_REQUIRED_ERROR: "Please select an image dimension",
  SPECIFICATIONS_REQUIRED_ERROR: "Please select a specifications",
  SCRIPT_LENGTH_REQUIRED_ERROR: "Please select a script length",
  ASSET_TYPE_REQUIRED_ERROR: "Please select an asset type",
  PRODUCT_IMAGE_OPTION_ERROR: "Please select a product image to generate background",
};

export const defaultRadioOption = {
  id: "",
  label: "",
};

const { SELECT_DROPDOWN_LABEL } = PROJECT_OPTIONS_CONSTANT;

export const customRenderField = {
  label: SELECT_DROPDOWN_LABEL,
  labelClassName: "mb-[-1rem] font-[14px] font-roboto_mono font-bold uppercase",
  contentClassName: "",
};

export const DEFAULT_ASPECT_RATIO = "1:1";
